// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import { navigationLogoItemPropType } from '../propTypes';
import styled from '../utils/styled';
import { mediaBreakpointUpSM } from '../../constants/style-constants';

const PrimaryNavigationLogo = ({ logo }) => (
  <PrimaryNavigationLogoWrapper href={logo.link}>
    <LogoImage id="nav-center-logo-image" src={logo.image.file.url} alt={logo.image.title} />
  </PrimaryNavigationLogoWrapper>
);

const PrimaryNavigationLogoWrapper = styled.a({
  /* stylelint-disable selector-type-case, selector-type-no-unknown,
  string-quotes, font-family-name-quotes */
  display: 'block',
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  lineHeight: '1',
  color: 'white',

  '&:hover': {
    color: 'white',
  },
});

const LogoImage = styled.img({
  width: '160px',
  height: '15px',

  [mediaBreakpointUpSM]: {
    width: '200px',
    height: '20px',
  },
});

PrimaryNavigationLogo.propTypes = {
  logo: navigationLogoItemPropType.isRequired,
};

export default PrimaryNavigationLogo;
